import { Button, ButtonStrip, Modal, ModalActions, ModalContent, ModalTitle } from '@dhis2/ui';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../locales';
export function ConfirmUpdateModal(_ref) {
  let {
    clientsCount,
    onCancel,
    onConfirm
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, {
    position: "middle"
  }, /*#__PURE__*/React.createElement(ModalTitle, null, i18n.t('Save your data')), /*#__PURE__*/React.createElement(ModalContent, null, clientsCount ? i18n.t("Updating will reload all {{n}} open instances of this app, and any unsaved data will be lost. Save any data you need to, then click 'Reload' when ready.", {
    n: clientsCount
  }) : // Fallback if clientsCount is unavailable:
  i18n.t("Updating will reload all open instances of this app, and any unsaved data will be lost. Save any data you need to, then click 'Reload' when ready.")), /*#__PURE__*/React.createElement(ModalActions, null, /*#__PURE__*/React.createElement(ButtonStrip, {
    end: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel
  }, i18n.t('Cancel')), /*#__PURE__*/React.createElement(Button, {
    destructive: true,
    onClick: onConfirm
  }, i18n.t('Reload')))));
}
ConfirmUpdateModal.propTypes = {
  clientsCount: PropTypes.number,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};